import { If } from "react-conditional-components-renderer";
import classNames from "classnames";

import { useOutsideClick } from "@ascendnow/shared";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import AscHeading from "../../AscTypography/AscHeading/AscHeading";
import { MoreIcon } from "../../AscIcons";
import styles from "./AscMembersCard.module.scss";
import { useRef } from "react";

export interface AscMembersCardProps {
  className?: string;
  imageUrl?: string;
  name: string;
  position: string;
  isVerified: boolean;
  onClick: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onlyView?: boolean;
}

export default function AscMembersCard({
  className,
  imageUrl,
  name,
  position,
  isVerified,
  onlyView = false,
  onClick,
  onEdit,
  onDelete,
}: AscMembersCardProps) {
  const { ref, isVisible, setIsVisible } =
    useOutsideClick<HTMLDivElement>(false);
  const menuRef = useRef<HTMLDivElement>(null);
  return (
    <div
      ref={ref}
      data-testid="asc-members-card"
      className={classNames(styles.ground, className)}
      style={{ cursor: onlyView ? "auto" : "pointer" }}
      onClick={({ target }) => {
        if (
          !onlyView &&
          menuRef.current &&
          !menuRef.current?.contains(target as Node)
        ) {
          onClick?.();
        }
      }}
    >
      <div className={styles.imageGround}>
        <div
          className={classNames(styles.status, {
            [styles.active]: !!isVerified,
            // [styles.inactive]: status === "inactive",
            [styles.invite]: !isVerified,
          })}
        >
          <If test={!!isVerified}>
            <span>Active</span>
          </If>
          {/* <If test={status === "inactive"}>
            <span>Inactive</span>
          </If> */}
          <If test={!isVerified}>
            <span>Invite sent</span>
          </If>
        </div>
        {imageUrl ? (
          <img
            src={imageUrl}
            className={styles.image}
            alt="team_member_image"
          />
        ) : (
          <div className={styles.noImage} />
        )}
      </div>

      <div className={styles.content}>
        <AscHeading className={styles.name} level={6}>
          {name}
        </AscHeading>

        {(onEdit || onDelete) && !onlyView && (
          <div ref={menuRef} className={styles.moreIcon}>
            <MoreIcon
              className={styles.icon}
              onClick={() => setIsVisible(!isVisible)}
            />

            {isVisible && (
              <AscAdminAction
                option1={"Edit"}
                option2={"Delete"}
                clickOption1={onEdit}
                clickOption2={onDelete}
                className={styles.actionBar}
              />
            )}
          </div>
        )}

        <div className={styles.position}>
          <div className={styles.circle} />
          <span className={styles.text}>{position}</span>
        </div>
      </div>
    </div>
  );
}
